import { AlertCircleIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

export const AgenciesErrorAlert = (): ReactNode => (
  <Alert variant="destructive">
    <AlertCircleIcon className="size-4" />
    <AlertTitle>Error loading agencies</AlertTitle>
    <AlertDescription>
      There was a problem loading the agencies. Please try again later.
    </AlertDescription>
  </Alert>
)
